import React, { useState } from "react"
import { graphql, StaticQuery } from "gatsby"
import { Link } from "gatsby"

import styles from "./scss/navigation.module.scss"
import "./scss/hamburger.css"

const Navigation = ({ logo }) => {
  const [toggle, setToggle] = useState(false)

  const handleClick = () => {
    setToggle(prevToggle => !prevToggle)
  }

  const closeMenu = () => {
    setToggle(prevToggle => !prevToggle)
  }

  return (
    <nav className={styles.nav}>
      <section className={styles.innerWrapper}>
        <div className={styles.top}>
          <Link
            to="/"
            className={styles.logo}
            aria-label="Content Visit Logo"
          >
            <picture>
              <source
                srcSet={logo.logo.fixed.srcWebp}
                type="image/webp"
              />
              <source
                srcSet={logo.logo.fixed.src}
                type="image/png"
              />
              <img
                src={logo.logo.fixed.src}
                alt={logo.logo.description}
                aria-label="Content Visit Logo"
              />
            </picture>
          </Link>
          <button
            onClick={handleClick}
            className={`hamburger hamburger--3dxy ${
              toggle ? "is-active" : ""
            }`}
            type="button"
            role="menu"
            aria-owns="span1 span2"
            aria-label="Menu"
          >
            <span id="span1" className="hamburger-box">
              <span id="span2" className="hamburger-inner" />
            </span>
          </button>
        </div>
        <ul className={`${styles.ulLinks} ${toggle ? styles.ulOpen : ""}`}>
          <li>
            <hr />
          </li>
          <li>
            <Link
              to="/about"
              activeClassName={styles.active}
              onClick={closeMenu}
            >
              About
            </Link>
          </li>
          <li>
            <Link
              to="/services"
              activeClassName={styles.active}
              onClick={closeMenu}
            >
              Services
            </Link>
          </li>
          {/* <li>
            <Link
              to="/pricing"
              activeClassName={styles.active}
              onClick={closeMenu}
            >
              Pricing
            </Link>
          </li> */}
          <li>
            <Link
              to="/work"
              activeClassName={styles.active}
              onClick={closeMenu}
            >
              Case studies
            </Link>
          </li>
          <li>
            <Link
              to="/articles"
              activeClassName={styles.active}
              onClick={closeMenu}
            >
              Articles
            </Link>
          </li>

          <li>
            <Link
              to="/contact"
              activeClassName={styles.active}
              className={styles.highlight}
              onClick={closeMenu}
            >
              Get In Touch
            </Link>
          </li>
        </ul>
      </section>
    </nav>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        logo: contentfulCompanyLogo {
          logo {
            description
            fixed(width: 250) {
              src
              srcWebp
            }
          }
        }
      }
    `}
    render={({ logo }) => <Navigation logo={logo} {...props} />}
  />
)
